import cx from "classnames";
import { useMemo } from "react";
import Clock from "@/components/svg/Clock";
import { getFormattedTime, timeUntil } from "@/utils/date";
import styles from "./raceTime.module.scss";

interface RaceTimeProps {
  postTime: string;
}

const RaceTime = ({ postTime }: RaceTimeProps) => {
  const numMinutes = timeUntil(postTime);
  const overOneHour = numMinutes >= 60;
  const underFiveMinutes = numMinutes < 5;
  const hasRaceStarted = numMinutes <= 0;

  const displayValue = useMemo(() => {
    if (overOneHour) {
      return getFormattedTime(postTime);
    }
    if (hasRaceStarted) {
      return "Resulted";
    }
    return `${numMinutes} Min Till Start`;
  }, [overOneHour, hasRaceStarted, numMinutes, postTime]);

  return (
    <span
      suppressHydrationWarning
      className={cx(styles.container, underFiveMinutes && styles.soon)}
    >
      <Clock />
      <span suppressHydrationWarning>{displayValue}</span>
    </span>
  );
};

export default RaceTime;
